import { render, staticRenderFns } from "./saidaProduto.vue?vue&type=template&id=20f0a0a9&scoped=true"
import script from "./saidaProduto.vue?vue&type=script&lang=js"
export * from "./saidaProduto.vue?vue&type=script&lang=js"
import style0 from "./saidaProduto.vue?vue&type=style&index=0&id=20f0a0a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0a0a9",
  null
  
)

export default component.exports